import {LanguageEnum} from "../models/enums/language.enum.ts";

const OVERRIDEN_ISO_LOCALES: Partial<Record<LanguageEnum, string>> = {
    [LanguageEnum.EN_GB]: 'en-GB',
    [LanguageEnum.EN_US]: 'en-US',
    [LanguageEnum.NO]: 'nb-NO',
    [LanguageEnum.SV]: 'sv-SE',
};

export const getISOLocale = (locale: LanguageEnum): string => {
    return OVERRIDEN_ISO_LOCALES[locale] || locale;
};
